export default function AppSection() {
  return (
    <section id="app" className="w-full px-4 md:px-6 py-14 md:py-20 bg-background-100/50">
      <div className="max-w-5xl mx-auto">
        <div className="flex flex-col lg:flex-row items-center gap-8 lg:gap-14 bg-background-50 border border-background-200/60 rounded-2xl p-8 md:p-12">
          <div className="flex-shrink-0 w-24 h-24 md:w-32 md:h-32 rounded-2xl bg-gradient-to-br from-accent-500 to-primary-500 flex items-center justify-center shadow-lg shadow-accent-500/20">
            <i className="ri-smartphone-line text-background-50 text-4xl md:text-5xl"></i>
          </div>

          <div className="flex-1 text-center lg:text-left">
            <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-900 mb-3">
              移动观影
            </h2>
            <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-5">
              夜猫电影院完美适配手机和平板设备，无论何时何地打开浏览器即可畅享高清电影免费在线观看。优化移动网络播放体验，地铁通勤、睡前追剧都不卡顿不缓冲，让免费影院随身携带。
            </p>
            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <button
                type="button"
                className="inline-flex items-center gap-2 px-6 py-2.5 bg-foreground-900 hover:bg-foreground-800 text-background-50 font-medium rounded-full text-sm whitespace-nowrap cursor-pointer transition-colors"
              >
                <i className="ri-android-line text-lg"></i>
                Android 适配
              </button>
              <button
                type="button"
                className="inline-flex items-center gap-2 px-6 py-2.5 border border-background-300/60 text-foreground-700 hover:bg-background-100 font-medium rounded-full text-sm whitespace-nowrap cursor-pointer transition-colors"
              >
                <i className="ri-apple-line text-lg"></i>
                iOS 适配
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}